import { NgModule } from '@angular/core';
import { SharedModule } from '@pt/shared/shared.module';

@NgModule({
  declarations: [],
  imports: [SharedModule]
})
export class CoreModule {}
